module.exports = __webpack_public_path__ + "static/media/2020.5.8花桥社区 二居委共建.fbab6685.jpg";